export function setHref(url) {
  window.location.href = url;
}